class PdpInstallments extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this._drawer = this.querySelector('x-drawer');
    const disclosure = this.querySelector('.accordion__disclosure');
    this._drawer?.addEventListener('dialog:before-show', () => disclosure?.setAttribute('aria-expanded', 'true'));
    this._drawer?.addEventListener('dialog:before-hide', () => disclosure?.setAttribute('aria-expanded', 'false'));

    this.querySelector('[data-installment-drawer-open]')?.addEventListener('click', () => {
      this._drawer?.show();
    });
  }
}

if (!window.customElements.get('pdp-installments')) {
  window.customElements.define('pdp-installments', PdpInstallments);
}
